module.exports = __webpack_public_path__ + "img/supply-chain-h.2d31654b.svg";